const errorDict = {
  LOGIN_SUCCESS: "登录成功",
  DELETE_SUCCESS: "删除成功",
  INSERT_SUCCESS: "保存成功",
  LOGIN_FAIL: "登录失败",
  UN_LOGIN: "当前用户未登录",
  USER_UNKNOW_USERNAME: "用户名错误",
  USER_PASSWORD_ERROR: "密码错误",
  UPDATA_FAIL_ERROE_ATTRIBUTE: "旧密码错误",
  INSERT_FAIL_ERROE_ATTRIBUTE: "保存失败",
  UPDATA_SUCCESS: "修改成功",
  SELECT_FAIL_ERROE_ATTRIBUTE: "查询失败",
  SELECT_SUCCESS: "查询成功",
  UNAUTHORIZED: "前用户未授权",
  LOGOUT_SUCCESS: "登录退出成功",
  DATABASE_ERROR: "数据库异常",
  SERVICE_ERROR: "系统异常",
  REQUEST_METHOD_ERROR: "请求方法错误",
  UNKNOW_ERROR: "未知错误",
  SESSION_TIME_OUT: "登录超时",
  UPLOAD_FILE_SUCCESS: "文件上传成功",
  UPLOAD_FILE_FAIL: "文件上传失败",
  CREATE_VERITYCODE_FAIL: "生成验证码失败",
  CREATE_VERITYCODE_SUCCESS: "生成验证码成功",
  VERITYCODE_ERROE: "验证码错误",
  NULL_ATTRIBUTE: "参数为空异常",
  ALREADY_EXIST: "数据重复异常",
  UN_AUTHORIZATION: "",
  UN_AUTHORIZATION: "请求未授权",
  IMPORT_SUCCESS: "导入成功",
  IMPORT_FAIL: "导入失败",
  REL_SUCCESS: "关联成功",
  REL_FAIL: "关联失败",
  REL_SUCCESS: "取消成功",
  REL_FAIL: "取消失败",
  OPERATE_SUCCESS: "操作成功",
  OPERATE_FAIL: "操作失败",
};

/**
 * 获取错误信息
 * @param {*} errorKey
 * @returns
 */
export const getTipsMessage = (errorKey) => {
  if (errorDict.hasOwnProperty(errorKey)) {
    return errorDict[errorKey];
  } else {
    return errorKey;
  }
};
